"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Eye: function() {
        return Eye;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Eye = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3.05951 12C4.35368 15.4745 7.84974 18 12 18C16.1503 18 19.6463 15.4745 20.9405 12C19.6463 8.52551 16.1503 6 12 6C7.84974 6 4.3537 8.52548 3.05951 12ZM1.05013 11.6873C2.52461 7.20774 6.88883 4 12 4C17.1112 4 21.4754 7.20778 22.9499 11.6874C23.0167 11.8905 23.0167 12.1096 22.9499 12.3127C21.4754 16.7923 17.1112 20 12 20C6.88883 20 2.52458 16.7922 1.05013 12.3126C0.983289 12.1095 0.98329 11.8904 1.05013 11.6873ZM11.9994 10C10.7707 10 9.85547 10.9391 9.85547 12C9.85547 13.0609 10.7707 14 11.9994 14C13.2281 14 14.1433 13.0609 14.1433 12C14.1433 10.9391 13.2281 10 11.9994 10ZM7.85547 12C7.85547 9.74722 9.75545 8 11.9994 8C14.2434 8 16.1433 9.74722 16.1433 12C16.1433 14.2528 14.2434 16 11.9994 16C9.75545 16 7.85547 14.2528 7.85547 12Z",
        fill: "currentColor"
    })
}), "Eye");
const _default = Eye;
